export default "__VITE_ASSET__vxYe3Mdk__"